{
    "websiteName": "Adevărul Financiar",
    "websitePushID": "web.adevarulfinanciar.ro",
    "allowedDomains": [
        "https://adevarulfinanciar.ro",
        "https://www.adevarulfinanciar.ro"
    ],
    "urlFormatString": "https://adevarulfinanciar.ro/%@",
    "authenticationToken": "dfbe6e83e1347f43d6545ed330",
    "webServiceURL": "https://adevarulfinanciar.ro/apple_webpush"
}
